<template>
  <div>
    <section class="container topo-intermediaria">
      <div class="row">
        <div class="col-12 col-md-4">
          <img :src="requireFoto" :alt="`${curso.titulo}`" class="img-fluid mt-3" />
        </div>
        <div class="col-12 col-md-8">
          <h1>{{ curso.titulo }}</h1>
          <p v-html="curso.descricao"></p>
          <div class="intermediaria-curso-expirado" v-if="cursoComDataExpiracao">
            <p>
              <span><strong>{{ curso.progresso }}% do curso concluído</strong></span>
              <span v-if="curso.dataExpiracao && isCursoExpirado"><strong>Curso expirado em {{ formatDate(curso.dataExpiracao) }}</strong></span>
              <span v-else-if="curso.dataExpiracao && !isCursoExpirado"><strong>Curso expira em {{ formatDate(curso.dataExpiracao) }}</strong></span>
            </p>
          </div>
          <div class="mb-5">
            <a @click="$router.push(urlSalaAula)" href="javascript:void(0)" class="btn btn-primary" v-if="!isCursoExpirado">{{ $t('irParaCursoLink') }}</a>
          </div>
        </div>
      </div>
    </section>
    <section class="destaques-logado">
      <div class="container">
        <div class="row align-items-center">
          <div class="col" v-if="qtdeVideos != 0">
            <div class="d-flex align-items-center mt-md-4 ml-md-5">
              <i class="fas fa-video"></i>
              <div>
                <p><animated-number :value="qtdeVideos" :formatValue="formatIntegerNumber" :duration="800"/></p>
                <p>{{ $t('videos') }}</p>
              </div>
            </div>
          </div>
          <div class="col" v-if="qtdeHoras != '0H0'">
            <div class="d-flex align-items-center mt-md-4 ml-md-5">
              <i class="fas fa-clock"></i>
              <div>
                <p>{{ qtdeHoras }}</p>
                <p>{{ $t('horas') }}</p>
              </div>
            </div>
          </div>
          <div class="col" v-if="qtdeAnexos != 0">
            <div class="d-flex align-items-center mt-md-4 ml-md-5">
              <i class="fas fa-book-open"></i>
              <div>
                <p><animated-number :value="qtdeAnexos" :formatValue="formatIntegerNumber" :duration="800"/></p>
                <p>{{ $t('resumos') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="conteudo-intermediaria">
      <div class="container">
        <div class="tab-curso pt-5 mb-3" v-if="resumos.length > 0 || referencias.length > 0">
          <div class="row">
            <div class="col-6">
              <h2 class="sobre-curso mr-3" v-bind:class="{ active: tabs.sobreCurso }" @click="alternaTab('sobreCurso')">Sobre o Curso</h2>
            </div>
            <div class="col-6">
              <h2 class="material-extra ml-3" v-bind:class="{ active: tabs.materialCurso }" @click="alternaTab('materialCurso')">Material Extra</h2>
            </div>
          </div>
        </div>
        <div class="row" v-if="tabs.sobreCurso">
          <div class="col-12 col-md-6">
            <h2>{{ $t('ementa') }}</h2>
            <div v-for="(modulo, indexModulo) in modulos" class="btn-disc cat1">
              <b-link v-b-toggle="`col-mod-${indexModulo}`">
                {{modulo.titulo}}
              </b-link>
              <b-collapse :id="`col-mod-${indexModulo}`">
                <ul>
                  <li v-for="(licao, indexLicao) in modulo.licoes">
                    <div class="btn-disc cat1">
                      <b-link v-b-toggle="`col-mod-${indexModulo}-lic-${indexLicao}`">
                        {{licao.titulo}}
                      </b-link>
                      <b-collapse :id="`col-mod-${indexModulo}-lic-${indexLicao}`">
                        <ul>
                          <template v-for="topico in licao.topicos">
                            <li v-if="topico.tipo != 7 || (topico.tipo == 7 && licao.simulados.length == 0)">
                              <a @click="$router.push(topico.urlSalaAula)" href="javascript:void(0)">
                                <i :class="topico.tipoTopico.icone" v-if="topico.tipoTopico.icone"></i>  {{ topico.titulo }}
                              </a>
                            </li>
                          </template>
                            <li v-for="simulado in licao.simulados"><a @click="$router.push(simulado.urlSalaAula)" href="javascript:void(0)"><i class="fas fa-list-ul"></i>  {{ simulado.simulado }}</a></li>
                        </ul>
                      </b-collapse>
                    </div>
                  </li>
                </ul>
              </b-collapse>
            </div>
          </div>

          <div class="col-12 col-md-6">
            <h2 v-if="coordenadores.length">Coordenadores</h2>
            <professor :professores="coordenadores" v-if="coordenadores.length" />
            <h2 v-if="professores.length">{{ $t('professores') }}</h2>
            <professor :professores="professores" v-if="professores.length" />
          </div>

        </div>
        <div class="row" ref="material-extra" v-if="tabs.materialCurso">
          <div class="col-12 col-md-6" v-if="resumos.length > 0">
            <h2>Resumos do curso</h2>
            <div class="resumo" v-for="resumo in resumos" v-bind:key="resumo.url">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <img :src="iconeResumo" class="img-fluid" />
                  <div>
                      <div>
                        <p>{{ resumo.titulo }}</p>
                      </div>
                  </div>
                </div>
                <div>
                  <a class="btn btn-secondary" target="_blank" :href="obterCaminhoCompleto(resumo.url)">
                    <i class="fas fa-arrow-alt-circle-down mr-1"></i> Visualizar
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6" v-if="referencias.length > 0">
            <h2>Referencias do curso</h2>
            <div class="referencia" v-for="referencia in referencias" v-bind:key="referencia.url">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <img :src="urlImagem('img/livro.png')" />
                  <div>
                    <div>
                    <p>{{ referencia.referencia }}</p>
                    </div>
                  </div>
                </div>
                <a class="btn btn-secondary" target="_blank" :href="referencia.url">
                  <i class="fas fa-external-link-square-alt mr-1"></i> Ver online
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import CursosAPI from '@/api/cursos-api'
import AnimatedNumber from 'animated-number-vue'
import Professor from '@/modules/SalaAula/components/apoio-topico/Professor'
import CategoriasAPI from '@/api/categorias-api'
import ImageUtils from '@/core/utils/image-utils'
import TipoTopico, { TipoTopicoUtil } from '@/core/types/tipo-topico-licao'
import DateUtils from '@/core/utils/date-utils'

export default {
  name: 'EmentaCursoApp',
  components: { Professor, AnimatedNumber },
  data () {
    return {
      curso: {
        titulo: '',
        descricao: '',
        foto: ''
      },
      tabs: {
        sobreCurso: true,
        materialCurso: false
      },
      urlSalaAula: '',
      qtdeVideos: 0,
      qtdeHoras: '0',
      qtdeAnexos: 0,
      professores: [],
      coordenadores: [],
      resumos: [],
      referencias: [],
      modulos: [],
      iconeResumo: null
    }
  },
  created () {
    if (this.$configEmpresa.materialExtra && this.$configEmpresa.materialExtra.iconeResumo) {
      this.iconeResumo = `${process.env.VUE_APP_BASE_FILES_URL}empresas/imgs/${process.env.VUE_APP_EMPRESA_REF}/${this.$configEmpresa.materialExtra.iconeResumo}`
    } else {
      this.iconeResumo = this.urlImagem('img/resumo.png')
    }
  },
  computed: {
    requireFoto: function () {
      return ImageUtils.obterUrlCompletaImagem(`${this.curso.foto}`, 'cursos-plataforma/')
    },
    cursoComDataExpiracao: function () {
      return this.$empresaUtils.temAcesso(this.$tipoAcesso.CURSO_DATA_EXPIRACAO.nome, this.$configEmpresa.rotasRestritasAcesso)
    },
    isCursoExpirado: function () {
      if (this.cursoComDataExpiracao && this.curso.dataExpiracao) {
        return this.curso.dataExpiracao < DateUtils.currentDateTime()
      } else {
        return false
      }
    }
  },
  mounted () {
    const idCurso = parseInt(this.$route.params.idCurso)

    this.obterCurso(idCurso)
  },

  watch: {
    '$store.getters.exibicaoCursoDetalhe': async function () {
      this.obterCurso(this.$store.getters.exibicaoCursoDetalhe.id)
    },
    '$route' () {
      this.obterCurso()
    }
  },

  methods: {
    async obterCurso (idCurso) {
      const $loader = this.$loading.show()

      let referenciaCurso = this.$route.params.referenciaCurso

      if (idCurso) {
        let curso = await CategoriasAPI.listarSistemas().then(data => {
          const cursos = data.categorias.flatMap(categoria => categoria.sistemas.flatMap(sistema => sistema.cursos))

          return cursos.find(curso => curso.id === idCurso)
        })

        if (!curso) {
          curso = await CategoriasAPI.listarDisciplinas().then(data => {
            const cursos = data.categorias.flatMap(categoria => categoria.disciplinas.flatMap(disciplina => disciplina.cursos))
            return cursos.find(curso => curso.id === idCurso)
          })
        }

        if (curso) {
          referenciaCurso = curso.url
        }
      }

      CursosAPI.obterResumoQuantitativo(referenciaCurso).then(data => {
        this.qtdeVideos = data.videos_curso

        this.qtdeHoras = `${data.horas_curso ? data.horas_curso : 0}H${data.minutos_curso ? data.minutos_curso : 0}`

        this.qtdeAnexos = data.anexos_curso
      })

      CursosAPI.obterDetalheEmenta(referenciaCurso).then(data => {
        const $ementaCurso = data.ementas

        this.curso = { titulo: $ementaCurso.nome,
          descricao: $ementaCurso.descricao,
          foto: $ementaCurso.foto,
          dataExpiracao: $ementaCurso.dataExpiracao,
          progresso: $ementaCurso.progresso
        }

        this.resumos = data.resumos
        this.referencias = data.referencias
        this.coordenadores = $ementaCurso.coordenadores
        this.professores = $ementaCurso.professores
        this.modulos = $ementaCurso.modulos
        this.urlSalaAula = `/sala-de-aula/${referenciaCurso}`

        if (this.modulos) {
          this.modulos.forEach(modulo => {
            modulo.licoes.forEach(licao => {
              let index = 1
              licao.topicos.forEach(topico => {
                if (topico.tipo) {
                  const tipoTopico = TipoTopicoUtil.obterTipoTopicosPorId(topico.tipo)
                  if (tipoTopico === TipoTopico.QUESTAO_OBJETIVA || tipoTopico === TipoTopico.QUESTAO_DISCURSIVA) {
                    topico.titulo = `${topico.ordemQuestao ? topico.ordemQuestao : index++}ª Questão - ${licao.titulo}`
                  }
                  topico.tipoTopico = Object.assign({}, tipoTopico)
                }
                topico.urlSalaAula = `/sala-de-aula/${referenciaCurso}/${modulo.referencia}/${licao.referencia}/${topico.referencia}`
              })
              licao.simulados.forEach(simulado => {
                simulado.urlSalaAula = `/sala-de-aula/${referenciaCurso}/${modulo.referencia}/${licao.referencia}/simulado-${simulado.id}`
              })
            })
          })
        }
        $loader.hide()
      })
    },

    formatIntegerNumber (value) {
      return Number(value).toFixed(0)
    },

    obterURLLicaoSalaAula () {
      return ''
    },

    alternaTab (tab) {
      if (tab === 'sobreCurso') {
        this.tabs.sobreCurso = true
        this.tabs.materialCurso = false
      }

      if (tab === 'materialCurso') {
        this.tabs.sobreCurso = false
        this.tabs.materialCurso = true
      }
    },

    urlImagem: function (url) {
      return ImageUtils.obterUrlCompletaImagem(url)
    },

    obterCaminhoCompleto: function (resumo) {
      return ImageUtils.obterUrlCompletaImagem(`${resumo}`, 'apostila-web/')
    },

    formatDate: function (date) {
      let pattern = 'DD/MM/YYYY'
      return DateUtils.formatDate(date, pattern)
    }
  }
}
</script>

<style>
  section.topo-intermediaria p:first-child {
    text-transform: inherit!important;
  }
</style>
